import { useState } from "react"

type AuthModalState = {
  isOpen: boolean
  onMount?: () => void
  onLogin?: () => void
  shouldRedirect?: boolean
}

const useAuthModal = () => {
  const [state, setState] = useState<AuthModalState>({ isOpen: false })

  const open = (options: { onMount?: () => void; onLogin?: () => void; shouldRedirect?: boolean }) => {
    const { onMount, onLogin, shouldRedirect } = options
    setState((prev) => {
      if (prev.isOpen) {
        return prev
      }
      return { isOpen: true, onMount, onLogin, shouldRedirect }
    })
  }

  const close = () => {
    setState({ isOpen: false })
  }

  return { authModalProps: { ...state, close }, open }
}

export default useAuthModal
